module.exports = __webpack_public_path__ + "static/media/core.6f8f0686.svg";